Object.defineProperty(exports, '__esModule', { value: true });

var useCustomIcons = function () {
    var getCustomIcons = function (getBadgeIcons) {
        if (getBadgeIcons) {
            return getBadgeIcons;
        }
        return null;
    };
    return { getCustomIcons: getCustomIcons };
};

exports.useCustomIcons = useCustomIcons;
